<template>
  <div id="navMenu" style="overflow-x:hidden">
    <el-menu
      :collapse="collapse"
      :default-active="$store.getters.activeMenu"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#282C34"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <div v-for="(list, index) in routeList" :key="index">
        <!-- 没有子菜单 -->
        <el-menu-item
          @click="openMenu(list)"
          :index="list.path"
          v-if="list.meta.show && !list.meta.hasChildren && list.meta.level == 1"
        >
          <i :class="list.meta.icon"></i>
          <span slot="title">{{list.meta.title}}</span>
        </el-menu-item>
        <!-- 有子菜单 -->
        <el-submenu
          :index="list.path"
          v-if="list.meta.show && list.meta.hasChildren && list.meta.level == 1"
        >
          <template slot="title">
            <i :class="list.meta.icon"></i>
            <span v-show="!collapse">{{list.meta.title}}</span>
          </template>
          <div v-for="(subItem, i) in list.meta.children" :key="i">
            <!-- 没有三级 -->
            <el-menu-item
              @click="openMenu(subItem)"
              :index="subItem.path"
              v-if="subItem.meta.show && !subItem.meta.hasChildren && subItem.meta.level == 2"
            >
              <i :class="subItem.meta.icon"></i>
              <span slot="title">{{subItem.meta.title}}</span>
            </el-menu-item>
            <!-- 有三级 -->
            <el-submenu
              :index="subItem.path"
              v-if="subItem.meta.show && subItem.meta.hasChildren && subItem.meta.level == 2 "
            >
              <template slot="title">
                <i :class="subItem.meta.icon"></i>
                <span slot="title">{{subItem.meta.title}}</span>
              </template>
              <div v-for="(ss, s) in subItem.meta.children" :key="s">
                <el-menu-item
                  @click="openMenu(ss)"
                  :index="ss.path"
                  v-if="ss.meta.show && !ss.meta.hasChildren && ss.meta.level == 3"
                >
                  <i :class="ss.meta.icon"></i>
                  <span slot="title">{{ss.meta.title}}</span>
                </el-menu-item>
                <!-- add lk 2020.5.9 start -->
                <el-submenu
                  :index="ss.path"
                  v-if="ss.meta.show && ss.meta.hasChildren && ss.meta.level == 3 "
                >
                  <template slot="title">
                    <i :class="ss.meta.icon"></i>
                    <span slot="title">{{ss.meta.title}}</span>
                  </template>
                  <div v-for="(sss, sindex) in ss.meta.children" :key="sindex">
                    <el-menu-item
                      @click="openMenu(sss)"
                      :index="sss.path"
                      v-if="sss.meta.show && !sss.meta.hasChildren && sss.meta.level == 4"
                    >
                      <i :class="sss.meta.icon"></i>
                      <span slot="title">{{sss.meta.title}}</span>
                    </el-menu-item>
                  </div>
                </el-submenu>
                <!-- add lk 2020.5.9 end -->
              </div>
            </el-submenu>
          </div>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapse: false,
      routeList: [],
      collapseTitle: "收起",
      collapseIcon: "el-icon-s-fold"
      // menuList: []
    };
  },
  mounted() {
    // window.onresize = () => {
    //   return (() => {
    //     if (document.body.clientWidth < 1024) {
    //       this.collapse = true;
    //     } else {
    //       this.collapse = false;
    //     }
    //   })();
    // };
  },
  created() {
    this.routeList = this.$store.getters.c_menu;
    this.getParent(0, this.routeList);
  },
  methods: {
    getParent(id, data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].meta.parentId == id) {
          data[i].meta.children = this.getChild(this.routeList, data[i].id);
          if (data[i].meta.hasChildren) {
            this.getParent(data[i].id, data[i].meta.children);
          }
        }
      }
    },
    getChild(data, parentId) {
      let children = [];
      data.forEach(element => {
        if (element.meta.parentId == parentId) {
          children.push(element);
        }
      });
      children.sort((a, b) => {
        return a.meta.index - b.meta.index;
      });
      return children;
    },
    // getMenu(menuList, parent) {
    //   var topMenu = this.getParent(parent, menuList)
    //   if(topMenu.length > 0){
    //     topMenu.forEach(element => {
    //       this.getMenu(menuList, element.meta.id)
    //     });
    //   }
    // },

    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    openMenu(data) {
      if (data.meta.keepAlive == 1) {
        this.$router.push(data.path);
      } else {
        let routeUrl = this.$router.resolve(data.path);
        window.open(routeUrl.href, "_blank");
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-menu-vertical-demo {
  height: 100vh;
}
// 20200609 tz add start
/deep/ .el-menu {
  border-right: none;
}
// 20200609 tz add end
</style>


// WEBPACK FOOTER //
// src/views/common/NavMenu.vue